import Component from "../../lib/component";
import offerBadgeSvg from "./assets/offer_badge.svg";

export const OfferBadgeConfig = {
  componentTypeKey: "OfferBadge",
  baseHtmlClass: "offer_badge",
  selector: ".offer_badge",

  datasetConfigKey: "offer_badge__config",
  labelBaseHtmlClass: "offer_badge__label",
  svgBaseHtmlClass: "offer_badge__svg",
};

export class OfferBadge extends Component {
  static get config() {
    return OfferBadgeConfig;
  }

  constructor(id_or_element) {
    super({
      element: id_or_element,
      config: OfferBadge.config,
    });

    this.setDatasetConfig(OfferBadge.config.datasetConfigKey);
    this.label = this.getDatasetConfigValue("label");
    this.description = this.getDatasetConfigValue("description");
    this.url = this.getDatasetConfigValue("url");

    this.renderInitial();

    if (this.url) {
      this.element.addEventListener("click", this.handleClick.bind(this));
    }

    this.render();
  }

  handleClick() {

  }

  renderInitial() {
    this.element.style.display = null;
    const labelHtml = `<div class="${OfferBadgeConfig.labelBaseHtmlClass}">${this.label}</div>`;
    const svgHtml = `<div class="${OfferBadgeConfig.svgBaseHtmlClass}">${offerBadgeSvg}</div>`;
    this.element.innerHTML = `${svgHtml}${labelHtml}`;
    if (this.url) this.addHtmlClassState("clickable");
  }

  render() {

  }
}
